var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChildMe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Child_Me_svg__a,.Child_Me_svg__b{fill:none}.Child_Me_svg__b{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Child_Me_svg__a",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Child_Me_svg__b",
    d: "M9.511 7.572a2.252 2.252 0 11-3.185 0 2.252 2.252 0 013.185 0M19.051 10.453a1.364 1.364 0 11-1.929 0 1.364 1.364 0 011.929 0M7.918 13.135c2.574 0 5.088 1.112 5.088 2.822v.57a.566.566 0 01-.565.565H3.395a.566.566 0 01-.565-.565v-.57c0-1.711 2.513-2.822 5.088-2.822M18.087 14.694c1.559 0 3.081.673 3.081 1.709v.342a.342.342 0 01-.342.342h-5.478a.342.342 0 01-.342-.342v-.342c0-1.036 1.522-1.709 3.081-1.709"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "Child_Me_svg__a",
    d: "M0 0h24v24H0z"
  })));
}
export default SvgChildMe;


//////////////////
// WEBPACK FOOTER
// ./src/components/Quoters/Aflac/icons/Child_Me.svg
// module id = 1082
// module chunks = 13